import React from "react";
import SEO from "@/components/SEO";
import PageHero from "@/components/site/PageHero";

const sections = [
  { h: "1. Acceptance of Terms", p: "By accessing or using the Web Vantage Enterprises website and services, you agree to be bound by these Terms & Conditions. If you do not agree, please do not use our services." },
  { h: "2. Services", p: "We provide digital agency services including design, development, marketing and related consulting. The specific scope, deliverables and timelines for any engagement are defined in a separate written agreement or statement of work." },
  { h: "3. Intellectual Property", p: "All content on this website — including text, graphics, logos and code — is the property of Web Vantage Enterprises unless otherwise stated. Upon full payment, ownership of custom deliverables transfers to the client as defined in the project agreement." },
  { h: "4. Payment Terms", p: "Fees, payment schedules and invoicing terms are specified in each project agreement. Late payments may incur additional charges and may pause active work." },
  { h: "5. Client Responsibilities", p: "Clients agree to provide timely feedback, materials and approvals necessary for project delivery. Delays caused by the client may affect timelines and costs." },
  { h: "6. Limitation of Liability", p: "Web Vantage Enterprises is not liable for indirect, incidental or consequential damages arising from the use of our services, to the maximum extent permitted by law." },
  { h: "7. Termination", p: "Either party may terminate an engagement in accordance with the terms of the project agreement. Fees for work completed up to termination remain payable." },
  { h: "8. Governing Law", p: "These terms are governed by the laws of the jurisdiction in which Web Vantage Enterprises operates, without regard to conflict of law principles." },
];

export default function Terms() {
  return (
    <>
      <SEO title="Terms & Conditions" description="The terms and conditions governing the use of Web Vantage Enterprises services." path="/terms" />
      <PageHero overline="Legal" title="Terms & Conditions" subtitle="Last updated January 2026" crumbs={[{ label: "Terms & Conditions" }]} />
      <section className="py-20 lg:py-28">
        <div className="container-wv max-w-3xl space-y-10">
          <p className="text-base leading-relaxed text-slate-400">
            Please read these Terms & Conditions carefully before using our website or engaging our services.
          </p>
          {sections.map((s) => (
            <div key={s.h}>
              <h2 className="font-heading text-xl font-semibold text-white">{s.h}</h2>
              <p className="mt-3 text-base leading-relaxed text-slate-400">{s.p}</p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
